import { CANDY_APPLE } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UITableHoverCell from 'UIComponents/table/UITableHoverCell';
import UITableHoverContent from 'UIComponents/table/UITableHoverContent';
import UITruncateString from 'UIComponents/text/UITruncateString';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { formatNumberForEnrollmentConversionReporting, formatPercentageForEnrollmentConversionReporting } from 'automation-ui-canvas/containers/enrollment-conversion/enrollmentConversionUtils';
import { getEnrollmentHistoryListUrl } from 'automation-ui-canvas/utils/urls';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentConversionPanelSummaryRow = ({
  action,
  flow,
  getHeaderTitle,
  isReportingEnabled,
  enrollmentConversionData
}) => {
  var _conversionReport$act, _conversionReport$tot;
  const actionId = action.actionId;
  const trackEvent = useTrackEvent();
  const conversionReport = enrollmentConversionData === null || enrollmentConversionData === void 0 ? void 0 : enrollmentConversionData.conversionReport;
  const history = useHistory();
  const {
    search
  } = useLocation();
  const searchParams = useMemo(() => new URLSearchParams(search), [search]);
  const activeActionId = searchParams.get('activeActionId');
  const {
    executionErrors = 0,
    actionCompleted = 0,
    workflowCompleted = 0,
    failed = 0,
    unenrolled = 0
  } = (_conversionReport$act = conversionReport === null || conversionReport === void 0 ? void 0 : conversionReport.actionStatusCounts[action.getActionId()]) !== null && _conversionReport$act !== void 0 ? _conversionReport$act : {};
  const totalEnrollmentCount = (_conversionReport$tot = conversionReport === null || conversionReport === void 0 ? void 0 : conversionReport.totalEnrollmentCount) !== null && _conversionReport$tot !== void 0 ? _conversionReport$tot : 0;
  // for actions which are parent to end markers, we need to rely on workflowCompleted
  const actionCompletedCount = actionCompleted + workflowCompleted;

  // The sum of all enrollments that reached the action
  const reachedEnrollments = actionCompletedCount + failed + unenrolled;
  const errorPercentage = reachedEnrollments !== 0 ? executionErrors / reachedEnrollments * 100 : 0;
  const completedPercentage = totalEnrollmentCount !== 0 ? actionCompletedCount / totalEnrollmentCount * 100 : 0;
  const navigateToEnrollmentHistoryPanel = () => {
    searchParams.set('actions', `${action.getActionId()}`);
    searchParams.set('showVersions', 'true');
    searchParams.delete('activeActionId');
    history.push({
      pathname: getEnrollmentHistoryListUrl({
        flowId: flow.flowId
      }),
      search: searchParams.toString()
    });
    trackEvent(Trackables.AGGREGATE_PERFORMANCE_CLICK_MATCHING_ENROLLMENTS);
  };
  const scrollTo = activeElement => {
    // Setting the minimal timeout to give summary expandable section enough time to expand
    setTimeout(() => {
      return activeElement && activeElement.scrollIntoView({
        block: 'center'
      });
    }, 200);
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    title: isReportingEnabled ? /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "automation.enrollmentConversion.panel.tooltips.summary",
      options: {
        completedPercentage: formatPercentageForEnrollmentConversionReporting(completedPercentage),
        totalEnrollments: formatNumberForEnrollmentConversionReporting(totalEnrollmentCount),
        errorPercentage: formatPercentageForEnrollmentConversionReporting(errorPercentage),
        reachedEnrollments: formatNumberForEnrollmentConversionReporting(reachedEnrollments)
      }
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation.enrollmentConversion.panel.summaryTable.defaultState.tooltip"
    }),
    children: /*#__PURE__*/_jsxs("tr", {
      className: activeActionId === actionId.toString() ? 'is--selected-item' : '',
      ref: activeActionId === actionId.toString() ? scrollTo : null,
      children: [/*#__PURE__*/_jsx(UITableHoverCell, {
        hoverContent: /*#__PURE__*/_jsx(UITableHoverContent, {
          children: /*#__PURE__*/_jsx(UIButton, {
            size: "extra-small",
            use: "tertiary-light",
            onClick: navigateToEnrollmentHistoryPanel,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.enrollmentConversion.panel.summaryTable.viewTheseEnrollmentsButton"
            })
          })
        }),
        tooltip: false,
        children: /*#__PURE__*/_jsx(UIFlex, {
          direction: "column",
          children: /*#__PURE__*/_jsx(UILink, {
            onClick: navigateToEnrollmentHistoryPanel,
            children: /*#__PURE__*/_jsx(UITruncateString, {
              children: getHeaderTitle({
                actionId
              })
            })
          })
        })
      }), /*#__PURE__*/_jsx("td", {
        className: "text-right",
        children: isReportingEnabled ? formatNumberForEnrollmentConversionReporting(actionCompletedCount) : /*#__PURE__*/_jsx(UITruncateString, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.panel.summaryTable.defaultState.count"
          })
        })
      }), isReportingEnabled ? /*#__PURE__*/_jsx("td", {
        className: "text-right",
        style: executionErrors > 0 ? {
          color: CANDY_APPLE,
          fontWeight: 600
        } : {},
        children: formatNumberForEnrollmentConversionReporting(executionErrors)
      }) : /*#__PURE__*/_jsx("td", {
        className: "text-right",
        children: /*#__PURE__*/_jsx(UITruncateString, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.enrollmentConversion.panel.summaryTable.defaultState.count"
          })
        })
      })]
    })
  });
};
export default EnrollmentConversionPanelSummaryRow;